import { useSearchParams } from '@frontend/hooks/useSearchParams'

type QueryData = {
  sort_by?: string
  event_name?: string
}

type UseEventsSearchProps = {
  currentSort?: string
  searchTerm?: string
  setLoading: (loading: boolean) => void
}

function useEventsSearch({ currentSort, searchTerm, setLoading }: UseEventsSearchProps) {
  const sortQuery = currentSort !== undefined ? { sort_by: currentSort } : {}
  const searchQuery = searchTerm ? { event_name: searchTerm } : {}

  const queryData: QueryData = {
    ...sortQuery,
    ...searchQuery,
  }

  useSearchParams<QueryData>({
    queryData,
    partialReloadKeys: ['events', 'activeSearch'],
    setLoading,
  })
}

export default useEventsSearch